module.exports = __webpack_public_path__ + "static/media/snoopyclearsky03.8f6efa5e.jpg";